export default __webpack_public_path__ + "static/media/r_wdt_c_0_1.ca412aca.mp3";